import { ENGLISH_IQ_RETAKE_AFTER_DAYS } from '@repo/config';

const MILLISECONDS_PER_DAY = 86_400_000;

export const ASSESSMENT_EXPOSURE_POLICY = Object.freeze({
  maximumOverlapRatio: 0.25,
  windowMs: ENGLISH_IQ_RETAKE_AFTER_DAYS * MILLISECONDS_PER_DAY,
});
